<div class="image-section-wrapper">
  <div (filesChangeEmitter)="onImageSelection($event)" *ngIf="!imageForm.value.imageUrl && !loading"
  [id]="data?.layoutData?.uuid"
       appDragDrop
       class="w-full upload-image-section input-separator flex flex-col items-center justify-center">
    <div>
      <app-icon class="upload-icon" svgIcon="upload-icon" (click)="heroImage.click()"></app-icon>
    </div>
    <div>
      <div class="label-text text-center w-full font-work-sans font-regular mt-[1rem]" (click)="heroImage.click()">
        Drag and drop an Image or,
      </div>
      <br>
      <input #heroImage (change)="onImageSelection($event.target.files)" hidden id="file" name="file" type="file" accept="jpeg, jpg, image/jpg, image/png, image/jpeg, png, image/webp, webp">
      <div (click)="heroImage.click()"
           class="find-resources text-center underline w-full font-work-sans font-regular">
        Browse files to Upload
      </div>
    </div>
  </div>
  <!--      image preview-->
  <div *ngIf="imageForm.value.imageUrl && !loading" class="image-preview-section mt-[1rem]" [id]="data?.layoutData?.uuid">
    <div class="image-preview-delete-icon">
      <app-icon (click)="deleteSelectedImage()" class="delete-bold-icon cursor-pointer"
                svgIcon="delete-bold"></app-icon>
    </div>
    <app-image [url]="imageForm.value.imageUrl | cdnBaseUrl"></app-image>
  </div>
  <!-- loading -->
  <div *ngIf="loading" class="h-full w-full flex justify-center items-center">
    <mat-spinner
    mode="indeterminate"
    strokeWidth="5"
    [diameter]="100"
  />
  </div>
</div>
